<template>
    <div class="tyres_table_tech_info_b2b">

        <p class="titles pl-10">{{$t('tech-info.tyres-table.title')}}</p>
        <p class="model pl-10">{{vehicleModel}}</p>

        <div class="div-content d-flex flex-column align-items-center mt-10 mb-16 pl-10 pr-10" v-if="tableOptions !== null || tableDua !== null">
            <table cols="12" v-if="tableDua !== null">
                <thead>
                    <tr>
                        <th class="first_th">
                            {{$t('tech-info.tyres-table.table-dua.th1')}}
                        </th>
                        <th>
                            {{$t('tech-info.tyres-table.table-dua.th2')}}
                        </th>
                        <th>
                            {{$t('tech-info.tyres-table.table-dua.th3')}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="td-medidas">
                            {{$t('tech-info.tyres-table.table-dua.td1')}}
                        </td>
                        <td>
                            {{tableDua.tyreSize}}
                        </td>
                        <td>
                            {{tableDua.tyreSizeR}}
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="invisible-div"><span>Tyres Table</span></div>
            <table cols="12" v-if="tableOptions !== null">
                <thead>
                    <tr>
                        <th class="first_th">
                            <!-- {{$t('tech-info.tyres-table.table-options.th1')}} -->
                        </th>
                        <th>
                            {{$t('tech-info.tyres-table.table-options.th2')}}
                        </th>
                        <th>
                            {{$t('tech-info.tyres-table.table-options.th3')}}
                        </th>
                        <th>
                          {{$t('tech-info.tyres-table.table-options.th4')}}
                        </th>
                        <th>
                          {{$t('tech-info.tyres-table.table-options.th5')}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(option, index) in tableOptions" :key="index">
                        <td class="outras_opcoes">
                          {{
                            Number.isInteger(tableOptions.length/2) ?
                            tableOptions.length/2 == index ?
                              $t('tech-info.tyres-table.table-options.th1')
                            :
                              ''
                            :
                              Math.floor(tableOptions.length/2) == index ?
                              $t('tech-info.tyres-table.table-options.th1')
                            :
                              ''
                          }}
                        </td>
                        <td>
                            {{option.frontTyreSize}}
                        </td>
                        <td>
                            {{option.rimSizeF}}
                        </td>
                        <td>
                          {{option.rearTyreSize}}
                        </td>
                        <td>
                          {{option.rimSizeR}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="div-content2 d-flex flex-column align-items-center mt-2 mb-2 pl-10 pr-10" v-if="tableOptions == null && tableDua == null">
            <span>{{$t('tech-info.tyres-table.no-info')}}</span>
        </div>
    </div>
</template>

<script>
export default {

    /** @param expected
        tableOptions: {
            "primaryOption": {
                "tyreSize": "string",
                "tyreSizeR": "string",
                "loadIndex": "string",
                "loadIndexR": "string",
                "tyrePressure": "string",
                "tyrePressureR": "string",
                "speedIndex": "string",
                "speedIndexR": "string",
                "runflatf": "string",
                "runflatr": "string"
            },
            "options": [
                {
                "tyreSize": "string",
                "tyreSizeR": "string",
                "loadIndex": "string",
                "loadIndexR": "string",
                "tyrePressure": "string",
                "tyrePressureR": "string",
                "speedIndex": "string",
                "speedIndexR": "string",
                "runflatf": "string",
                "runflatr": "string"
                }
            ]
        }
    */

    props: {
        tableOptions: Array | Object,
        tableDua: Array | Object
    },

    // watch: {
    //     tableOptions: {
    //         handler: function (newValue, oldValue) {
    //             console.log('newValue tableOptions', newValue);
    //             return newValue;
    //         },
    //         deep: true,
    //         immediate: true,
    //     },
    //     tableDua: {
    //         handler: function (newValue, oldValue) {
    //             console.log('newValue tableDua', newValue);
    //             return newValue;
    //         },
    //         deep: true,
    //         immediate: true,
    //     }
    // },

    computed: {
      vehicleModel() {
          let title = '';
          if (this.$store.getters['vehicleIdentification/getState'].data.length) {
              this.$store.getters['vehicleIdentification/getState'].data.filter((value, index) => {
                  if (value.description == 'Make') {
                      title = value.value;
                  }

                  if (value.description == 'Model') {
                      title += ' ';
                      title += value.value;
                  }
              });

              return title;
          }

      },
    }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';


.tyres_table_tech_info_b2b {
    overflow: auto;
    background: white;

    .titles {
        font-size: 2rem;
        color: #4B4849;
    }

    .model {
        font-size: 12px;
        color: #4B4849;
    }

    .invisible-div {
        background: white;
        span {
            color: white;
        }
    }

        table {
            width: 100%;
            text-align: left;
            border-spacing: 0 5px;
            color: $grey-dark;
            font-family: Lato;
            border-bottom: 1px solid $grey-border-tab;
            border-left: 1px solid $grey-border-tab;
            border-right: 1px solid $grey-border-tab;


        thead {
            tr {
                border-bottom: 1px solid $grey-border-tab;

                th {
                    font-size: 14px;
                    background-color: #E6E5E5;
                    padding: 8px 18px;
                    border-bottom: 1px solid $grey-border-tab;
                    line-height: 20px;
                    letter-spacing: 0.28px;
                    font-weight: 500;
                    color: #4B4849;
                    text-align: center;
                }
            }
        }

        tbody {
            tr {
            background-color: transparent;

                td {
                    padding: 0;
                    background-color: $grey-soft;
                    padding: 8px 18px;
                    color: $grey-dark;
                    border-bottom: 1px solid $grey-border-tab;
                    text-align: center;
                    border-right: 1px solid $grey-border-tab;
                }

                .td-medidas {
                    background: #F2F2F2 ;
                }

                .base-class {
                    background: #F2F2F2;
                    border-right: 1px solid $grey-border-tab;
                }

                .outras_opcoes {
                    background: #F2F2F2;
                    border-bottom: 0px;
                    border-right: 1px solid $grey-border-tab;
                }
            }
        }

        tbody tr:nth-child(even) {
            background: $grey-soft;
        }
        tbody tr:nth-child(even) td {
            /* background: #E6E5E5; */
        }

        .outras_opcoes {
            background: #F2F2F2 !important;
            border-bottom: 0px;
            border-right: 1px solid $grey-border-tab !important;
        }

        .first_th {
          width: 20%;
        }
    }

}
</style>
